<template>
  <Field
    v-slot="{ errors }"
    ref="basicInput"
    :name="id"
    :rules="rules"
    :modelValue="content"
  >
    <div
      v-click-outside="clickOutside"
      class="basic-input"
      :class="[computedClass, { 'basic-input_results': showSearchResult, 'is-error': errors[0] }]"
    >
      <icon
        v-if="searchIcon"
        data="@icon/loupe.svg"
        :fill="false"
        width="var(--icon-24)"
        height="var(--icon-24)"
        class="basic-input__search-icon"
      />
      <input
        :id="id"
        :ref="elRef"
        type="text"
        :placeholder="placeholder"
        :value="modelValue"
        @input="handleInput($event.target.value)"
        @keyup.enter="$emit('enter')"
        @change="$emit('onChange', $event)"
      />
      <slot
        v-if="modelValue && showSearchResult"
        name="searchResult"
      />
      <button
        class="basic-input__remove"
        :class="{ 'is-show': showRemoveButtonAlways || (modelValue?.length && showRemoveButton) }"
        @click.prevent.stop="$emit('remove')"
      >
        <icon
          data="@icon/close2.svg"
          :fill="true"
          width="1em"
          height="1em"
        />
      </button>
      <span
        v-if="errors[0]"
        class="error-text bordered-input__error"
      >
        {{ errors[0] }}
      </span>
    </div>
  </Field>
</template>

<script lang="ts" setup>
import { directive as ClickOutside } from "click-outside-vue3"
import { Field } from "vee-validate"
import { computed, onMounted, watch } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  modelValue: { type: String, default: "" },
  id: { type: String, required: true },
  placeholder: { type: String, default: "Search" },
  showRemoveButton: { type: Boolean, default: false },
  showRemoveButtonAlways: { type: Boolean, default: false },
  showSearchResult: { type: Boolean, default: false },
  searchIcon: { type: Boolean, default: false },
  elRef: { type: String, default: "" },
  rules: { type: Function, default: () => true },
  class: { type: String, default: "" },
  focus: { type: Boolean, default: true }
})

const vClickOutside = ClickOutside
const emit = defineEmits(["update:modelValue", "blur", "remove"])

const store = useStore()
const isDark = computed(() => store.getters["Getters.THEME_IS_DARK"])

const setFocusOnInput = () => {
  if (props.focus && props.elRef) {
    const inputElement = document.querySelector(`#${props.id}`) as HTMLInputElement
    if (inputElement) {
      inputElement.focus()
    }
  }
}

const handleInput = (value: string) => {
  emit("update:modelValue", value)
}

const clickOutside = () => {
  emit("blur")
}

const content = computed(() => props.modelValue)
const computedClass = computed(() => props.class)

watch(
  () => props.focus,
  newFocus => {
    if (newFocus) {
      setFocusOnInput()
    }
  }
)

onMounted(() => {
  if (props.focus) {
    setFocusOnInput()
  }
})
</script>
